__turbopack_context__.v({
  "root": "chip-module-scss-module__1uqrsa__root",
});
